import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  paper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: 'calc(100% - 12px)',
    marginBottom: theme.spacing(2),
  },
  rowWide: {
    position: 'relative',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  title: {
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  input: {
    width: 'calc(100% - 170px)',
    color: 'rgb(0 0 0 / 87%)',
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
  },
  inputError: {
    width: 'calc(100% - 170px)',
    color: 'rgb(0 0 0 / 87%)',
    marginBottom: theme.spacing(-2.8),
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  btn: {
    padding: theme.spacing(1, 2),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWide: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    margin: '5px',
    textTransform: 'none',
  },
  btnWideLeft: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    marginRight: 10,
  },
  imgBox: {
    width: 136,
    padding: 0,
  },
  fieldsBox: {
    width: 'calc(100% - 140px)',
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
  },
  tableBox: {
    width: '100%',
    padding: 0,
  },
  userImg: {
    width: 136,
    height: 136,
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #5081FF',
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
  },
  actionBox: {
    position: 'absolute',
    right: 0,
  },
  halfSizeRow: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  link: {
    marginLeft: theme.spacing(7),
    display: 'flex',
    alignItems: 'flex-end',
    color: '#737373',
  },
}));
